// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"670":"405e0c8d","3204":"6415c241","3252":"1766d2fc","3868":"b6a7035f"}[chunkId] + ".chunk.css");